import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Description } from '../volkswagen.types';

@Component({
  selector: 'app-vw-designation',
  imports: [CommonModule],
  standalone: true,
  template: `
    @if (data.text) {
      <span>
        {{ data.text }}
      </span>
    }

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class DesignationComponent extends XMLElementBaseComponent<Description> {}
